import update from "immutability-helper";
import * as CreDtos from "../CRE.dtos";

import {
    CONTACTUSSETTINGS_REQUEST,
    CONTACTUSSETTINGS_REQUEST_SUCCESS,
    CONTACTUSSETTINGS_REQUEST_FAILURE,
    CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST,
    CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST_FAILURE,
    CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS
} from "../actions/contactUsSettings.actions";

const initialState = {
    contactUsSettings: {},
    isLoading: true,
    isSaving: false
};

function loading(state, isLoading) {
    let newState = update(state, {
        isLoading: { $set: isLoading }
    });
    return newState;
}

function saving(state, isSaving) {
    let newState = update(state, {
        isSaving: { $set: isSaving }
    });
    return newState;
}

function setContactUsSettings(state, contactUsSettings) {
    let newState = update(state, {
        contactUsSettings: { $set: contactUsSettings }
    });
    return newState;
}

export default function people(state = initialState, action) {
    switch (action.type) {
        case CONTACTUSSETTINGS_REQUEST:
            return loading(state, true);
        case CONTACTUSSETTINGS_REQUEST_SUCCESS:
            return setContactUsSettings(loading(state, false), action.contactUsSettings);
        case CONTACTUSSETTINGS_REQUEST_FAILURE:
            return loading(state, false);
        
        case CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST:
            return saving(state, true);
        case CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS:
            return saving(setContactUsSettings(state, action.contactUsSettings), false);
        case CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST_FAILURE:
            return saving(state, false);
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/contactUsSettings.ts